import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import config from '../../config'
import { VueEasyJwt } from 'vue-easy-jwt'
import { createHostedLinksGuard } from './hostedLinks2Guard'
import createTomaUsadosGuard from './tomaUsadosGuard'
import { createTomaUsadosReturnTo } from '../util/tomaUsadosLink'

const jwt = new VueEasyJwt()
Vue.use(VueRouter)
const tomaUsadosGuard = createTomaUsadosGuard(store)
const tomaUsadosBeforeEnter = (to, from, next) => tomaUsadosGuard(to, from, target => {
  const returnTo = createTomaUsadosReturnTo(to.path, to.query.ficha)
  if (target && target.path === '/login' && returnTo) {
    return next({ ...target, query: { ...(target.query || {}), returnTo } })
  }
  next(target)
})

const routes = [
  {
    path: '/comunicaciones',
    name: 'Comunicaciones',
    component: () => import('../views/Comunicaciones.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/arca',
    name: 'ARCA Homologación',
    component: () => import('../views/arca/Arca.vue'),
    meta: { requireAuth: true, rutaProtegida: true }
  },
  {
    path: '/toma-usados',
    name: 'TomaUsados',
    component: () => import('../views/usados/TomaUsados.vue'),
    meta: { requireAuth: true },
    beforeEnter: tomaUsadosBeforeEnter
  },
  {
    path: '/links-de-pago-2',
    name: 'HostedLinks2',
    component: () => import('../views/HostedLinks2.vue'),
    meta: { requireAuth: true },
    beforeEnter: createHostedLinksGuard(store)
  },
  // ----------------------------------
  //           PAGOS / PAYWAY
  // ----------------------------------
  // OJO con el orden: las rutas estáticas van ANTES de /pagos/:id para que
  // el parámetro dinámico no las capture.
  {
    path: '/pagos',
    name: 'Gestion Pagos',
    component: () =>
      import(
        /* webpackChunkName: "pagos" */ '../views/GestionPagosLinks.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/pagos/resultado',
    name: 'Resultado Pago',
    component: () =>
      import(/* webpackChunkName: "pagos" */ '../views/PagoResultado.vue')
  },
  {
    path: '/pagos/:id',
    name: 'Pago',
    component: () =>
      import(/* webpackChunkName: "pagos" */ '../views/Pagos.vue')
  },

  // ----------------------------------
  //           PAYMENT (PÚBLICO)
  // ----------------------------------
  // Checkout personalizado Dycar: URL pública generada por el admin
  // ({URL_FRONT}/payment/:id) para cobrar con Payway sin login.
  {
    path: '/payment/:id',
    name: 'PaymentCheckout',
    component: () =>
      import(
        /* webpackChunkName: "pagos" */ '../views/PaymentCheckout.vue'
      )
  },

  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/patentamiento',
    name: 'Patentamiento',
    component: () =>
      import(
        /* webpackChunkName: "patentamiento" */ '../views/Patentamiento.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/patentamiento/formularios',
    name: 'Formularios Patentamiento',
    component: () =>
      import(
        /* webpackChunkName: "patentamiento" */ '../views/patentamiento/FormulariosPatentamiento.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/instructivos',
    name: 'Instructivos',
    component: () =>
      import(
        /* webpackChunkName: "instructivos" */ '../views/Instructivos.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/archivos',
    name: 'Importar Archivos',
    component: () =>
      import(/* webpackChunkName: "archivos" */ '../views/Archivos.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/actualizar/servicios',
    name: 'Actualizar Servicios',
    component: () =>
      import(
        /* webpackChunkName: "actualizar" */ '../views/ActualizarServicios.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  // ----------------------------------
  //           CONFIGURACION
  // ----------------------------------
  // sufijo: /conf
  {
    path: '/conf/menu',
    name: 'Menu',
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/MenuLat.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/conf/roles',
    name: 'Roles',
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/Roles.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/conf/perfiles',
    name: 'Perfiles',
    redirect: '/conf/usuarios'
  },
  {
    path: '/conf/menus-nuevo',
    name: 'Menus Nuevo',
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/MenusNuevo.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/conf/rutas-nuevo',
    name: 'Rutas Nuevo',
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/RutasNuevo.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/conf/funciones-nuevo',
    name: 'Funciones Nuevo',
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/FuncionesNuevo.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/conf/menu-rutas-funciones',
    name: 'Menu-Rutas-Funciones',
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/MenuRutasFunciones.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/conf/usuarios',
    name: 'Usuarios',
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/Usuarios.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/conf/rutas',
    name: 'Rutas',
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/Rutas.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/conf/funciones',
    name: 'Funciones',
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/Funciones.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  // ----------------------------------
  //           COBRO ONLINE
  // ----------------------------------
  {
    path: '/cobro-online',
    name: 'Cobro Online',
    component: () =>
      import(/* webpackChunkName: "cobro" */ '../views/CobroOnline.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },

  // ----------------------------------
  //           NOTIFICACIONES
  // ----------------------------------
  {
    path: '/notificaciones',
    name: 'Notificaciones',
    component: () =>
      import(
        /* webpackChunkName: "notificaciones" */ '../views/Notificaciones.vue'
      ),
    meta: { requireAuth: true }
  },

  // ----------------------------------
  //            USADOS
  // ----------------------------------
  // sufijo: /usados

  {
    path: '/usados/vehiculos',
    name: 'Vehiculos',
    component: () =>
      import(/* webpackChunkName: "usados" */ '../views/usados/Vehiculos.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },

  {
    path: '/usados/vehiculos/:id?',
    name: 'Detalle de Vehiculo',
    component: () =>
      import(
        /* webpackChunkName: "usados" */ '../components/usados/DetalleVehiculo.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },

  {
    path: '/usados/precios',
    name: 'Precios',
    component: () =>
      import(/* webpackChunkName: "usados" */ '../views/usados/Precios.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },

  {
    path: '/usados/reparaciones',
    name: 'Reparaciones de usados',
    component: () =>
      import(/* webpackChunkName: "usados" */ '../views/usados/Reparaciones.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  // ----------------------------------
  //           COMISIONES PLANES DE AHORRO
  // ----------------------------------
  // sufijo: /pa
  {
    path: '/pa/cartera',
    name: 'Cartera',
    component: () =>
      import(/* webpackChunkName: "pa" */ '../views/pa/Cartera.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/pa/comisiones',
    name: 'Comisiones',
    component: () =>
      import(/* webpackChunkName: "pa" */ '../views/pa/Comisiones.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  // {
  //   path: '/pa/precios-modelos',
  //   name: 'Precios - Modelos',
  //   component: () =>
  //     import(/* webpackChunkName: "pa" */ '../views/pa/PreciosModelos.vue'),
  //   meta: {
  //     requireAuth: true,
  //     rutaProtegida: true
  //   }
  // },
  {
    path: '/pa/precios-modelos',
    name: 'Precios Modelos',
    component: () =>
      import(/* webpackChunkName: "pa" */ '../views/pa/PreciosModelosV2.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  // ----------------------------------
  //           PLANES DE AHORRO
  // ----------------------------------
  // sufijo: /planes
  {
    path: '/planes/recuperos',
    name: 'Recuperos',
    component: () =>
      import(/* webpackChunkName: "planes" */ '../views/planes/Recuperos.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/planes/ventas',
    name: 'Ventas',
    component: () =>
      import(/* webpackChunkName: "planes" */ '../views/planes/Ventas.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/planes/mantenimiento',
    name: 'Mantenimiento',
    component: () =>
      import(
        /* webpackChunkName: "planes" */ '../views/planes/Mantenimiento.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/planes/dashboard',
    name: 'Dashboard',
    component: () =>
      import(/* webpackChunkName: "planes" */ '../views/planes/Dashboard.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/planes/cartera',
    name: 'Cartera PA',
    component: () =>
      import(/* webpackChunkName: "planes" */ '../views/planes/Cartera.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/planes/recibos-efectivo',
    name: 'Recibos en efectivo',
    component: () =>
      import(
        /* webpackChunkName: "recivos-efectivo" */ '../views/planes/RecibosEfectivo.vue'
      ),
    meta: { requireAuth: true, rutaProtegida: true }
  },
  // ----------------------------------
  //           TALLER
  // ----------------------------------
  // sufijo: /taller
  {
    path: '/taller/ordenes-servicio',
    name: 'Ordenes de Servicio',
    component: () =>
      import(
        /* webpackChunkName: "taller" */ '../views/taller/OrdenesServicio.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/taller/lavadero',
    name: 'Lavadero',
    component: () =>
      import(
        /* webpackChunkName: "taller" */ '../views/lavadero/LavaderoKanban.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/taller/lavadero/metricas-historicas',
    name: 'Lavadero Métricas Históricas',
    component: () =>
      import(
        /* webpackChunkName: "taller" */ '../views/lavadero/LavaderoMetricasHistoricas.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },

  // ----------------------------------
  //            ADMINISTRACIÓN
  // ----------------------------------
  // sufijo: /administracion

  {
    path: '/administracion/comprobantes',
    name: 'Comp. Afip',
    component: () =>
      import(
        /* webpackChunkName: "administracion" */ '../views/administracion/ComprobantesAfip.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/administracion/retenciones-percepciones',
    name: 'Retenciones y percepciones',
    component: () =>
      import(
        /* webpackChunkName: "administracion" */ '../views/administracion/RetencionesPercepciones.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },

  {
    path: '/administracion/talonarios',
    name: 'ABM Talonarios',
    component: () =>
      import(
        /* webpackChunkName: "administracion" */ '../views/administracion/ABMTalonarios.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },

  {
    path: '/administracion/formularios',
    name: 'Gestion Formularios',
    component: () =>
      import(
        /* webpackChunkName: "administracion" */ '../views/administracion/GestionFormularios.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },

  {
    path: '/administracion/recibos-combustible',
    name: 'Recibos combustible',
    component: () =>
      import(
        /* webpackChunkName: "administracion" */ '../views/administracion/RecibosCombustible.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/administracion/iva',
    name: 'Reportes IVA',
    component: () =>
      import(
        /* webpackChunkName: "administracion" */ '../views/administracion/iva/ReportesIVA.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/administracion/renombrar-comprobantes',
    name: 'Renombrar Comprobantes',
    component: () =>
      import(
        /* webpackChunkName: "administracion" */ '../views/administracion/RenombrarComprobantes.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },

  // ----------------------------------
  //            COMISIONES SALON
  // ----------------------------------
  // sufijo: /comisiones-vn
  {
    path: '/comisiones-vn/ventas',
    name: 'Ventas salon',
    component: () =>
      import(
        /* webpackChunkName: "comisiones-vn" */ '../views/comisiones-salon/Ventas.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/comisiones-vn/comisiones',
    name: 'Comisiones VN',
    component: () =>
      import(
        /* webpackChunkName: "comisiones-vn" */ '../views/comisiones-salon/Comisiones.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },

  // ----------------------------------
  //           EX DUEÑO
  // ----------------------------------
  {
    path: '/usados/ex-duenio',
    name: 'Ex Dueño',
    component: () =>
      import(
        /* webpackChunkName: "stock" */ '../views/comisiones-salon/ExDuenio.vue'
      ),
    meta: { requireAuth: true }
  },

  // ----------------------------------
  //           INCIDENTES
  // ----------------------------------
  {
    path: '/incidentes',
    name: 'Incidentes',
    component: () =>
      import(
        /* webpackChunkName: "cobro" */ '../views/incidentes/Incidentes.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },

  // ----------------------------------
  //           Tickets
  // ----------------------------------
  {
    path: '/tickets',
    name: 'Tickets',
    component: () =>
      import(/* webpackChunkName: "cobro" */ '../views/tickets/Tickets.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/tickets/:id',
    name: 'Ticket detalle',
    component: () =>
      import(/* webpackChunkName: "cobro" */ '../views/tickets/Tickets.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },

  {
    path: '/mesa-tickets',
    name: 'Resolución de tickets',
    component: () =>
      import(
        /* webpackChunkName: "cobro" */ '../views/tickets/ResolucionTickets.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },

  // ----------------------------------
  //           Postventa
  // ----------------------------------
  // {
  //   path: '/postventa/tickets',
  //   name: 'Tickets Postventa',
  //   component: () =>
  //     import(/* webpackChunkName: "postventa" */ '../views/postventa/tickets/MisTicketsPostventa.vue'),
  //   meta: { requireAuth: true, rutaProtegida: true }
  // },
  {
    path: '/postventa/tickets/garantias',
    name: 'Gestión Tickets Garantías',
    component: () =>
      import(/* webpackChunkName: "postventa" */ '../views/postventa/tickets/GestionTicketsPostventa.vue'),
    meta: { requireAuth: true, rutaProtegida: true }
  },
  {
    path: '/postventa/tickets/reparacion-vehiculos-0km',
    name: 'Reparación Vehículos 0km',
    component: () =>
      import(/* webpackChunkName: "postventa" */ '../views/postventa/tickets/GestionTicketsReparacionVehiculos0km.vue'),
    meta: { requireAuth: true, rutaProtegida: true }
  },
  {
    path: '/postventa/recepcion-0km',
    name: 'Recepción 0km con daños',
    component: () =>
      import(/* webpackChunkName: "postventa" */ '../views/postventa/recepcion/Recepcion0kmDanos.vue'),
    meta: { requireAuth: true, rutaProtegida: true }
  },
  {
    path: '/postventa/archivo-unico',
    name: 'Archivo Unico',
    component: () =>
      import(/* webpackChunkName: "postventa" */ '../views/postventa/recepcion/RecepcionGarantias.vue'),
    meta: { requireAuth: true, rutaProtegida: true }
  },
  {
    path: '/postventa/tickets/pre-entregas',
    name: 'Pre Entregas',
    component: () =>
      import(/* webpackChunkName: "postventa" */ '../views/postventa/tickets/PreEntregas.vue'),
    meta: { requireAuth: true, rutaProtegida: true }
  },

  // ----------------------------------
  //           DESCARGAR ARCHIVO
  // ----------------------------------
  {
    path: '/descargarArchivo',
    name: 'Descargar Archivo',
    component: () =>
      import(
        /* webpackChunkName: "descargar-archivo" */ '../views/DescargarArchivo.vue'
      ),
    meta: { requireAuth: true, rutaProtegida: true }
  },

  // ----------------------------------
  //           CLASIFICACIÓN
  // ----------------------------------
  {
    path: '/conf/clasificacion-compras',
    name: 'Clasificación Compras',
    component: () =>
      import(
        /* webpackChunkName: "clasificacion-compras" */ '../views/admin/clasificacion/ClasificacionCompras.vue'
      ),
    meta: { requireAuth: true, rutaProtegida: true }
  },
  {
    path: '/conf/clasificacion-ventas',
    name: 'Clasificación Ventas',
    component: () =>
      import(
        /* webpackChunkName: "clasificacion-compras" */ '../views/admin/clasificacion/ClasificacionVentas.vue'
      ),
    meta: { requireAuth: true, rutaProtegida: true }
  },
  // ----------------------------------
  //           STOCK
  // ----------------------------------
  {
    path: '/stock',
    name: 'Stock 0km',
    component: () =>
      import(/* webpackChunkName: "stock" */ '../views/Stock.vue'),
    meta: { requireAuth: true, rutaProtegida: true }
  },
  // ----------------------------------
  //           BDC
  // ----------------------------------
  {
    path: '/bdc/informe',
    name: 'Informe',
    component: () =>
      import(/* webpackChunkName: "stock" */ '../views/call/Oportunidades.vue'),
    meta: { requireAuth: true }
  },

  // ----------------------------------
  //           Reportes USADOS
  // ----------------------------------
  {
    path: '/usados/reportes',
    name: 'Reportes',
    component: () =>
      import(/* webpackChunkName: "stock" */ '../views/usados/Reportes.vue'),
    meta: { requireAuth: true, rutaProtegida: true }
  },

  // ----------------------------------
  //           IMAGENES USADOS
  // ----------------------------------
  {
    path: '/usados/imagenes',
    name: 'Imagenes',
    component: () =>
      import(/* webpackChunkName: "stock" */ '../views/usados/Imagenes.vue'),
    meta: { requireAuth: true, rutaProtegida: true }
  },

  // ----------------------------------
  //           REPORTES
  // ----------------------------------
  {
    path: '/reportes',
    name: 'Reportes',
    component: () =>
      import(/* webpackChunkName: "stock" */ '../views/Reportes.vue'),
    meta: { requireAuth: true, rutaProtegida: true }
  },

  // ----------------------------------
  //           REVENDEDORES
  // ----------------------------------
  {
    path: '/abm-revendedores',
    name: 'ABMRevendedores',
    component: () =>
      import(
        /* webpackChunkName: "revendedores" */ '../views/revendedores/ABMRevendedores.vue'
      ),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/calidad/vouchers',
    name: 'Encuestas de Calidad',
    component: () =>
      import(/* webpackChunkName: "calidad" */ '../views/calidad/EncuestasCalidad.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
  {
    path: '/calidad/reporte',
    name: 'Reporte de Calidad',
    component: () =>
      import(/* webpackChunkName: "calidad" */ '../views/calidad/ReporteCalidad.vue'),
    meta: {
      requireAuth: true,
      rutaProtegida: true
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (is_auth()) {
      setTimeout(() => {
        store.dispatch('get_notificaciones_noleidas')
      }, 1)
      if (to.matched.some(record => record.meta.rutaProtegida)) {
        try {
          store.state.loading = true
          const res = await fetch(`${config.API_URL}/user/rutaValidaNuevo`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: JSON.parse(localStorage.getItem('token'))
            },
            body: JSON.stringify({
              path: to.path,
              redirect: true
            })
          })

          const data = await res.json()

          if (data.error != 'Forbidden') {
            next()
          } else {
            next({ path: '/' })
            store.dispatch('show_snackbar', {
              text: data.message || 'No tienes acceso a esta ruta',
              color: 'error'
            })
          }
          store.state.loading = false
        } catch (error) {
          next({ path: '/' })
          store.dispatch('show_snackbar', {
            text: error.message,
            color: 'error'
          })
        }
      } else {
        next()
      }
    } else {
      if (JSON.parse(localStorage.getItem('token'))) {
        store.dispatch('show_snackbar', {
          text: 'La sesión actual expiró',
          color: 'error'
        })
      }
      await store.dispatch('logout')
      const returnTo = createTomaUsadosReturnTo(to.path, to.query.ficha)
      next(returnTo ? { path: '/login', query: { returnTo } } : { path: '/login' })
    }
  } else {
    next()
  }
  window.scrollTo(0, 0)
})

function is_auth() {
  const token = JSON.parse(localStorage.getItem('token'))
  return !jwt.isExpired(token)
}

export default router
